module.exports = __webpack_public_path__ + "img/photo-delete.f6b055d9.svg";